module.exports = __webpack_public_path__ + "static/media/scheme-categories-ro.da7f86a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Home/assets/scheme-categories-ro.svg
// module id = 771
// module chunks = 20